import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import SwitchTab from 'UiKit/switch-tab';
import { useUserInfo } from 'Store/userInfo';
import { useHostStockPromoState } from 'View/host-stock-promo/state';
import { getTabStockPromoOptions } from './const';

import styles from './styles.module.css';

const Tab = () => {
  const { t } = useTranslation('host-stock-promo');
  const { state, updateState, updateFilterState } = useHostStockPromoState();
  const { userBrand } = useUserInfo();
  const { selectedTab } = state;

  const tabOptions = getTabStockPromoOptions(t);

  const onChangeTab = (newSelectedTab) => {
    if (selectedTab !== newSelectedTab) {
      updateState({ selectedTab: newSelectedTab });
      updateFilterState({ brandId: userBrand, stockStatus: [], promoStatus: [], store: [], search: '', page: 1 });
    }
  };

  return (
    <Box className={styles['tab__container']} transform={state?.showTopBar ? 'translateY(0)' : 'translateY(-42px)'} data-testid="tab">
      <SwitchTab options={tabOptions} value={selectedTab} handleChange={onChangeTab} variant="line" />
    </Box>
  );
};

export default Tab;
